import { useFieldArray, useFormContext } from 'react-hook-form';
import BadgeAssigneeEditAttribute, {
  type BadgeAssigneeEditAttributeFragment,
} from '@/components/Badge/BadgeAssigneeEditAttribute';
import type { ResultOf } from '@/gql/graphql';
import type { EventScorekeepingPanelFormValues } from '../../EventScorekeeping.types';

export default function EventScorekeepingPanelPreviewRecipientItemAttribute({
  attribute,
  index,
}: {
  attribute: ResultOf<typeof BadgeAssigneeEditAttributeFragment>;
  index: number;
}) {
  const { control } = useFormContext<EventScorekeepingPanelFormValues>();

  const { fields } = useFieldArray({
    control,
    name: `recipients.${index}.badge_assignee_attributes`,
  });

  const attributeIndex = fields.findIndex(
    (field) => field.badge_attribute.id === attribute.id,
  );

  return (
    <BadgeAssigneeEditAttribute
      isBottomSheet
      key={attribute.id}
      attribute={attribute}
      name={`recipients.${index}.badge_assignee_attributes.${attributeIndex}.value`}
    />
  );
}
